module.exports = __webpack_public_path__ + "static/media/foot-icon-full.f21411d0.svg";